// extracted by mini-css-extract-plugin
export default {"PaginatedList":"PaginatedList_PaginatedList__6ALDZ","table":"PaginatedList_table__9PV8B"};